import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";


const EditUserAPI = async (data) => {
    const user = useAuth()
    const url = APIURL + "/admin/edituser"
    return await axios.post(url, { access_token: user.token, ...data })
}

export default EditUserAPI